export const initGlobalSir = (options?: any) => {
  (function (
    a: { [key: string]: any },
    b: Document,
    c: string,
    d: string,
    e: string,
    f: any,
    g?: HTMLScriptElement,
    h?: Element,
    i?: any
  ) {
    a[e] ||
      ((i = a[e] =
        function () {
          (a[e].q = a[e].q || []).push(arguments);
        }),
        (i.l = 1 * new Date().getTime()),
        (i.o = f),
        (g = b.createElement(c) as HTMLScriptElement),
        (h = b.getElementsByTagName(c)[0]),
        (g.async = true),
        (g.src = d),
        g.setAttribute('n', e),
        h && h.parentNode ? h.parentNode.insertBefore(g, h) : null);
  })(
    window,
    document,
    'script',
    'https://widgets.sir.sportradar.com/c814e9d5f221568d30573d8e806e106e/widgetloader',
    'SIR',
    {
      theme: false,
      language: 'en',
      ...options,
    }
  );
}